import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection } from '@gik/ui';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { SamplePagesGrid } from '@gik/marketing/components/SamplePages';

export interface ISamplePagesSectionProps extends React.HTMLAttributes<HTMLUListElement> {}

export default function TipsSamplePagesSection({ className }: ISamplePagesSectionProps): React.ReactElement {
  const bem = bemBlock('tips-sample-pages-section');
  const { t } = useTranslation();

  return (
    <PageSection variant="solid-neutral" className={bem(null, null, className)} id="sample-pages">
      <h2 className={bem('title')}>{t(translationKeys.samplePages)}</h2>
      <SamplePagesGrid perPage={10} loadMoreButton />
    </PageSection>
  );
}
